import { Box, Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { addComponentToTaskTypeCols, getComponentDefaultValueForNewIntance, getTaskFormDesignerComponentType, TaskFormDesignerComponentType } from "source/components/task/TaskTypeDialog/TaskTypeDialogFormDesigner/FormDesignerComponentPicker";
import { AppUtils } from "source/framework/appUtils";
import { SaveDataObj } from "source/framework/saveData";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { ConfirmationDialogResult, TaskRepetitionType } from "ui/Scripts/source/models/enums";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import * as store from "../../../framework/customStore";
import * as appReportService from "../../../models/services/appReportService";
import { ISessionState } from "../../../models/session/sessionState";
import * as storeActions from "../../../models/store/storeActions";
import { CkEditorDialog } from "../../framework/Dialog/Dialog";
import { DialogButtons } from "../../framework/Dialog/DialogButtons";
import { DialogItemsNav } from "../../framework/Dialog/DialogItemsNav";
import { DialogTabs } from "../../framework/Dialog/DialogTabs";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { removeConfirmationWord } from "ui/Scripts/source/models/consts";
import { UnitBlocks } from "source/components/unit/UnitBlocks";
import { IRecordUnit, RecordUnit } from "ui/Scripts/source/models/unit/recordUnit";
import { getAppReportTemplateFromSchema, getSchemaFromAppReportTemplate, IAppReportTemplateFormModel } from "ui/Scripts/source/models/appReportTemplate/appReportTemplateFormModel";
import { getUpdatedTaskDataRow, ITaskTypeFieldPropUpdate, updateDefaultValueToDataRowCols, updateTaskTypeColPropUpdate, updateValueToDataRowCol } from "source/components/task/TaskTypeDialog/FormDesignerTypes";
import { IAppReportTemplateEditItem } from "ui/Scripts/source/models/appReportTemplate/appReportTemplateEditItem";
import { AppReportTemplateDialogBasicInformation } from "./AppReportTemplateDialogBasicInformation";
import { AppReportTemplateDialogFormDesigner } from "./AppReportTemplateDialogFormDesigner";
import { TaskTypeDialogPreview } from "source/components/task/TaskTypeDialog/TaskTypeDialogPreview";
import { TaskTypeDialogPreviewType } from "source/components/task/TaskTypeDialog/TaskTypeDialogPreview/TaskTypeDialogPreviewWeb";
import { TaskTypeDialogSchemaDialog } from "source/components/task/TaskTypeDialog/TaskTypeDialogSchemaDialog";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IdColorTitle, IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { getEventFiltersFromIdColorTitle, getEventFiltersFromNumberTitle, getEventIdTitleNodeFilters, getEventTypeFilters } from "source/components/event/EventPage/EventPageUtils";
import { getTaskStates } from "source/components/task/TaskPage/TaskPageUtils";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { IRecordCompanyFurtherEducationGroups } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordCompanyFurtherEducationGroups";

/* eslint-disable no-unused-vars */
export const enum AppReportTemplateDialogMenuItem {
    General = "1",
    Builder = "2",
    Preview = "3",
}
/* eslint-enable no-unused-vars */

interface IAppReportTemplateDialogProps {
    id: string;
    sessionState: ISessionState;
    companyId: string;
    hasPrevious: boolean;
    hasNext: boolean;
    addToCompany: boolean;
    onPrevious: () => void;
    onNext: () => void;
    onSaved: (id: string) => void;
    onClose: () => void;
    onRemove: (ids: string[]) => Promise<ApiSuccess>;
    onRefreshList: () => Promise<void>;
}

export interface IAppReportTemplateDialogState {
    activeMenuItem: AppReportTemplateDialogMenuItem;
    showSchemaDesignerDialog: boolean;
    code: string;
    comment: string;
    dataSchema: string;
    dataSchemaParseError: string;
    activeState: number;
    formDataRow: ITaskDataRow;
    appReportTemplate: IAppReportTemplateFormModel;
    item: IAppReportTemplateEditItem;
    rowId: string;
    formSelectedField: string;
    appReportUnits: IdTitleNode[];
    appReportTemplateUnits: IRecordUnit[];
    //EventReference related lists
    eventReports: IIdTitleNode[];
    eventUnits: IIdTitleNode[];
    eventStates: IIdTitle[];
    eventUrgencyClasses: IdColorTitle[];
    eventTypes: IIdTitleNode[];
    eventTypeBs: IIdTitleNode[];
    eventTypeCs: IIdTitleNode[];
    //TaskReference related lists
    taskTypes: ITaskEditTypeItem[];
    taskUnits: IIdTitleNode[];
    taskStates: IIdColorTitle[];
    //RecordReference related lists
    recordCharts: IIdTitle[];
    recordUnits: IIdTitleNode[];
    recordFurtherEducationGroups: IRecordCompanyFurtherEducationGroups[];
}

export const AppReportTemplateDialog = (props: IAppReportTemplateDialogProps) => {
    const orgStateHash = useRef<string>("");

    const [state, setState] = useState<IAppReportTemplateDialogState>({
        activeMenuItem: AppReportTemplateDialogMenuItem.General,
        showSchemaDesignerDialog: false,
        item: null,
        formDataRow: null,
        appReportTemplate: null,
        code: "",
        comment: "",
        dataSchema: "",
        dataSchemaParseError: "",
        activeState: 0,
        rowId: "",
        formSelectedField: "",
        appReportUnits: [],
        appReportTemplateUnits: [],
        //EventReference related lists
        eventReports: [],
        eventUnits: [],
        eventStates: [],
        eventUrgencyClasses: [],
        eventTypes: [],
        eventTypeBs: [],
        eventTypeCs: [],
        //TaskReference related lists
        taskTypes: [],
        taskUnits: [],
        taskStates: [],
        //RecordReference related lists
        recordCharts: [],
        recordUnits: [],
        recordFurtherEducationGroups: []
    });

    // const getAppReportTemplateFromSchema = (dataSchema: string): IAppReportTemplateSchemaParseResult => {
    //     const result = AppReportTemplateFormModel.getAppReportTemplateSchemaParseResult(dataSchema);
    //     if (!result.appReportTemplate) {
    //         return {
    //             appReportTemplate: state.appReportTemplate,
    //             formDataRow: state.formDataRow,
    //             error: result.error,
    //         };
    //     }
    //     return result;
    // };
    
    const getSchemaFromState = () => getSchemaFromAppReportTemplate(state.appReportTemplate);

    const getSaveDataFromState = (props: IAppReportTemplateDialogProps, state: IAppReportTemplateDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("id", state.item?.id);
        result.append("companyId", props.companyId);
        result.append("rowId", state.rowId);
        result.append("code", state.code);
        result.append("comment", state.comment);
        result.append("dataSchema", state.dataSchema);
        result.append("activeState", state.activeState);
        const isNew = state.item?.isNew() || false;
        result.append("unitIds", isNew
            ? state.appReportTemplateUnits.map(i => {
                return i.unitId;
            })
            : null);
        return result;
    };

    const checkErrors = (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            if (!state.code) {
                store.customStore.dispatch(storeActions.showErrorMessage(Translations.NameMustBeDefined));
                return resolve(false);
            }
            return resolve(true);
        });
    };

    const loadData = async (id: string, addToCompany: boolean) => {
        const result = await AppUtils.callService(() => appReportService.getAppReportTemplateEdit(props.companyId, id, addToCompany), false);
        if (!result) return;
        const item = result.item;
        const parseResult = getAppReportTemplateFromSchema(item.dataSchema, state.appReportTemplate, state.formDataRow);
        const stateChange = {
            item,
            appReportTemplate: parseResult.appReportTemplate,
            formDataRow: parseResult.formDataRow,
            code: item.code,
            comment: item.comment,
            dataSchema: item.dataSchema,
            dataSchemaParseError: parseResult.error,
            activeState: item.activeState,
            rowId: item.rowId,
            appReportUnits: result.units,
            appReportTemplateUnits: result.reportTemplateUnits,
            //EventReference related lists
            eventReports: result.eventReferenceData.eventReports,
            eventUnits: getEventIdTitleNodeFilters(result.eventReferenceData.eventUnits ? result.eventReferenceData.eventUnits : []),
            eventStates: getEventFiltersFromNumberTitle(result.eventReferenceData.eventStates ? result.eventReferenceData.eventStates : []),
            eventUrgencyClasses: getEventFiltersFromIdColorTitle(result.eventReferenceData.eventUrgencyClasses ? result.eventReferenceData.eventUrgencyClasses : []),
            eventTypes: getEventTypeFilters(result.eventReferenceData.eventTypes ? result.eventReferenceData.eventTypes : []),
            eventTypeBs: getEventTypeFilters(result.eventReferenceData.eventTypeBs ? result.eventReferenceData.eventTypeBs : []),
            eventTypeCs: getEventTypeFilters(result.eventReferenceData.eventTypeCs ? result.eventReferenceData.eventTypeCs : []),
            //TaskReference related lists
            taskTypes: result.taskReferenceData.taskTypes,
            taskUnits: getEventIdTitleNodeFilters(result.taskReferenceData.taskUnits ? result.taskReferenceData.taskUnits : []),
            taskStates: getTaskStates(result.taskReferenceData.taskStates ? result.taskReferenceData.taskStates : []),
            //RecordReference related lists
            recordCharts: result.recordReferenceData.recordCharts,
            recordUnits: getEventIdTitleNodeFilters(result.recordReferenceData.recordUnits ? result.recordReferenceData.recordUnits : []),
            recordFurtherEducationGroups: result.recordReferenceData.recordFurtherEducationGroups
        };
        setState((old) => ({
            ...old,
            ...stateChange,
        }));
        orgStateHash.current = getSaveDataFromState(props, { ...state, ...stateChange }).hash;
    };

    const handleFormSchemaReorder = (startIndex: number, endIndex: number) => {
        const result = Array.from(state.appReportTemplate.formCols);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        setState((old) => {
            const newAppReportTemplate = {
                ...old.appReportTemplate,
                formCols: result,
            };
            return {
                ...old,
                appReportTemplate: newAppReportTemplate,
                dataSchema: getSchemaFromAppReportTemplate(newAppReportTemplate)
            };
        });
    };

    const handleFormSchemaAddItem = (componentType: TaskFormDesignerComponentType, index: number, copyTaskTypeCol: ITaskTypeCol = null) => {
        setState((old) => {
            const result = addComponentToTaskTypeCols(old.appReportTemplate.formCols, componentType, index, copyTaskTypeCol);
            const dataRowCol = new TaskDataRowCol();
            dataRowCol.field = result.field;
            dataRowCol.valueStr = getComponentDefaultValueForNewIntance(componentType);
            const newAppReportTemplate = {
                ...old.appReportTemplate,
                formCols: [...result.typeCols],
            };
            const formDataRow = new TaskDataRow(state.formDataRow);
            formDataRow.cols = formDataRow.cols.filter(col => col.field !== result.field).concat([dataRowCol]);
            return {
                ...old,
                appReportTemplate: newAppReportTemplate,
                dataSchema: getSchemaFromAppReportTemplate(newAppReportTemplate),
                formDataRow,
                formSelectedField: result.field
            };
        });
    };

    const handleFormItemClick = (formSelectedField: string) => {
        setState((old) => ({
            ...old,
            formSelectedField
        }));
    };
    
    useEffect(() => {
        if (!props.id) return;
        loadData(props.id, props.addToCompany);
    }, [props.companyId, props.id, props.addToCompany]);

    const handleChange = (event: { target: any; }) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "code") {
            setState((old) => ({ ...old, code: value }));
        } else if (name === "name") {
            setState((old) => ({ ...old, name: value }));
        } else if (name === "comment") {
            setState((old) => ({ ...old, comment: value }));
        }
    };

    const saveToDb = async (): Promise<SaveSuccess> => {
        if (!await AppUtils.validate(checkErrors)) return null;
        const saveData = getSaveDataFromState(props, state);
        //Call server
        const result = await AppUtils.callService(() => appReportService.saveAppReportTemplateEdit(saveData.obj));
        if (!result) return null;
        //Update state and hash
        const stateChange = { id: result.id, rowId: result.rowId };
        orgStateHash.current = getSaveDataFromState(props, { ...state, ...stateChange }).hash;
        setState((old) => ({
            ...old,
            ...stateChange
        }));
        return result;
    };

    const handleSave = async (closeDialog: boolean) => {
        const result = await saveToDb();
        if (!result) return;
        if (!closeDialog) {
            loadData(result.id, false);
            props.onSaved(result.id);
            return;
        }
        props.onClose();
    };

    const handleRemove = async () => {
        if (state.item?.isNew()) return;
        if (await AppUtils.showConfirmationDialog(String.format(Translations.ReportTemplateRemoveConfirmation, state.item.code), false, removeConfirmationWord) === ConfirmationDialogResult.Yes) {
            // Call server
            const result = await props.onRemove([state.item?.id]);
            if (!result) return;
            props.onClose();
        }
    };

    const handleCancel = async () => {
        const cancelResult = await AppUtils.cancel(getSaveDataFromState(props, state).hash, orgStateHash.current, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            handleSave(true);
        } else {
            props.onClose();
        }
    };

    const canMoveOut = async (): Promise<boolean> => {
        return await AppUtils.canMoveOut(getSaveDataFromState(props, state).hash, orgStateHash.current,
            async () => !!(await saveToDb()),
            props.onRefreshList,
            (newStateHash) => { orgStateHash.current = newStateHash; });
    };

    const handlePrevious = async () => {
        if (!await canMoveOut()) return;
        setState((old) => ({
            ...old,
            formSelectedField: null
        }));
        props.onPrevious();
    };

    const handleNext = async () => {
        if (!await canMoveOut()) return;
        setState((old) => ({
            ...old,
            formSelectedField: null
        }));
        props.onNext();
    };

    const handleFormTaskTypePropUpdate = (values: ITaskTypeFieldPropUpdate[]) => {
        //TypeCol update
        const updated = updateTaskTypeColPropUpdate(state.appReportTemplate.formCols, values);
        const appReportTemplate = {
            ...state.appReportTemplate,
            formCols: updated.taskTypeCols
        };
        //Default value update for data row
        const formDataRow = new TaskDataRow(state.formDataRow);
        if (updated.typeCol) {
            for (const value of values) {
                if (value.name === "defaultStr" || value.name === "defaultNbr") {
                    updateDefaultValueToDataRowCols(formDataRow, updated.typeCol, value.field);
                }
            }
        }
        setState((old) => ({
            ...old,
            appReportTemplate,
            formDataRow,
            dataSchema: getSchemaFromAppReportTemplate(appReportTemplate)
        }));
    };
    
    const handleFormTaskDataRowValueUpdate = (field: string, name: string, value: string | number | boolean) => {
        if (!state.formDataRow) return;
        const formDataRow = new TaskDataRow(state.formDataRow);
        updateValueToDataRowCol(formDataRow, field, name, value);
        setState((old) => ({
            ...old,
            formDataRow
        }));
    };

    const handleFormRemoveComponent = async (field: string) => {
        if (await AppUtils.showConfirmationDialog(Translations.ReportTemplateRemoveFieldConfirmation, false) === ConfirmationDialogResult.No) {
            return;
        }
        const formDataRow = new TaskDataRow(state.formDataRow);
        formDataRow.cols = formDataRow.cols.filter(i => i.field !== field);
        setState((old) => {
            const newAppReportTemplate = {
                ...old.appReportTemplate,
                formCols: old.appReportTemplate?.formCols?.filter(item => item.field !== field)
            };
            return {
                ...old,
                appReportTemplate: newAppReportTemplate,
                dataSchema: getSchemaFromAppReportTemplate(newAppReportTemplate),
                formDataRow
            };
        });
    };

    const handleFormCopyComponent = async (id: string) => {
        const taskTypeCol = state.appReportTemplate.formCols.find(i => i.field === id);
        if (!taskTypeCol) return;
        const designerComponentType = getTaskFormDesignerComponentType(taskTypeCol);
        handleFormSchemaAddItem(designerComponentType, state.appReportTemplate.formCols.findIndex(i => i.field === id) + 1, taskTypeCol);
    };
    
    const handleOpenSchemaDialog = () => {
        setState((old) => ({
            ...old,
            dataSchema: getSchemaFromState(),
            showSchemaDesignerDialog: true,
        }));
    };

    const handleSaveSchemaDialog = (value: string) => {
        const parseResult = getAppReportTemplateFromSchema(value, state.appReportTemplate, state.formDataRow);
        setState((old) => ({
            ...old,
            appReportTemplate: parseResult.appReportTemplate,
            formDataRow: parseResult.formDataRow,
            dataSchemaParseError: parseResult.error,
            dataSchema: value,
            showSchemaDesignerDialog: false,
        }));
    };

    const handleCloseSchemaDialog = () => {
        setState((old) => ({ ...old, showSchemaDesignerDialog: false }));
    };

    const isNew = state.item?.isNew();

    // #region AppFormTemplateUnits
    const addUnits = async (units: IIdTitleNode[]): Promise<ApiSuccess> => {
        const addUnits = units.filter(i => !state.appReportTemplateUnits.find(j => j.unitId === i.id));
        if (!addUnits || addUnits.length < 1) return null;
        if (!isNew) {
            const result = await AppUtils.callService(() => appReportService.appReportTemplateAddUnits(props.companyId, state.item.id, addUnits.map(i => i.id)), true);
            if (!result) return null;
        }
        const appReportTemplateUnits = state.appReportTemplateUnits.slice(0);
        for (const unit of addUnits) {
            const recordUnit = new RecordUnit();
            recordUnit.id = Base.getGuid();
            recordUnit.unitId = unit.id;
            recordUnit.title = unit.title;
            appReportTemplateUnits.push(recordUnit);
        }
        setState((old) => ({ ...old, appReportTemplateUnits }));
        return new ApiSuccess();
    };

    const handleAddUnit = (unit: IIdTitleNode): Promise<ApiSuccess> => {
        if (!unit) return;
        return addUnits([unit]);
    };

    const handleRemoveUnits = async (unitIds: string[]): Promise<ApiSuccess> => {
        if (!unitIds || unitIds.length < 1) return;
        if (!isNew) {
            const result = await AppUtils.callService(() => appReportService.appReportTemplateRemoveUnits(props.companyId, state.item.id, unitIds));
            if (!result) return null;
        }
        setState((old) => ({ ...old, appReportTemplateUnits: old.appReportTemplateUnits.filter(i => unitIds.indexOf(i.unitId) < 0) }));
        return new ApiSuccess();
    };
    // #endregion AppFormTemplateUnits

    // #region Preview
    const handleUpdatFormDataRowCols = (taskDataRowCols: ITaskDataRowCol[]) => {
        const formDataRow = getUpdatedTaskDataRow(state.formDataRow, taskDataRowCols);
        setState((old) => ({
            ...old,
            formDataRow
        }));
    };
    // #endregion Preview

    if (!state.appReportTemplate) return null;

    return <CkEditorDialog
        id="appReportTemplateDialog"
        maxWidth="xl"
        maxHeight="100%"
        title={isNew ? Translations.AddReportTemplate : (Translations.ReportTemplate + ": " + state.item?.code)}
        dialogTabs={
            <DialogTabs
                activeTabId={state.activeMenuItem}
                tabs={[
                    { id: AppReportTemplateDialogMenuItem.General, title: Translations.BasicInformation },
                    { id: AppReportTemplateDialogMenuItem.Builder, title: Translations.ReportBuilder },
                    { id: AppReportTemplateDialogMenuItem.Preview, title: Translations.Preview },
                ]}
                onChangeTab={(activeMenuItem: AppReportTemplateDialogMenuItem) => setState((old) => ({ ...old, activeMenuItem }))}
            />
        }
        body={<Box display="flex" flexDirection="column" height="100%">
            {state.activeMenuItem === AppReportTemplateDialogMenuItem.General &&
                <Grid container height="100%">
                    <Grid item sm={props.companyId ? 8 : 12} height="100%">
                        <DialogSectionCard headerTitle={Translations.BasicInformation}>
                            <Grid sx={{
                                overflowY: "auto",
                                overflowX: "hidden",
                                height: "100%",
                                flexGrow: 1
                            }}>
                                <AppReportTemplateDialogBasicInformation
                                    code={state.code}
                                    comment={state.comment}
                                    activeState={state.activeState}
                                    item={state.item}
                                    isNew={isNew}
                                    onHandleChange={handleChange}
                                    onUpdateActiveState={(activeState) => setState((old) => ({ ...old, activeState }))}
                                />
                            </Grid>
                        </DialogSectionCard>
                    </Grid>
                    {!!props.companyId &&
                        <Grid item sm={4} sx={{ paddingLeft: "16px" }} height="100%">
                            <UnitBlocks
                                title={Translations.ReportTemplateUnits}
                                noUnitsMessage={Translations.ReportTemplateUsedInAllUnits}
                                showInPanel={true}
                                height="100%"
                                unitTree={state.appReportUnits}
                                units={state.appReportTemplateUnits.map(i => IdTitleNode.createIdTitleNode(i.unitId, i.title, []))}
                                onAddUnit={handleAddUnit}
                                onRemoveUnits={handleRemoveUnits}
                            />
                        </Grid>
                    }
                </Grid>
            }
            {state.activeMenuItem === AppReportTemplateDialogMenuItem.Builder &&
                <AppReportTemplateDialogFormDesigner
                    companyId={props.companyId}
                    appReportTemplate={state.appReportTemplate}
                    formDataRow={state.formDataRow}
                    formTypeCol={state.appReportTemplate?.formCols?.find(item => item?.field === state.formSelectedField)}
                    sessionState={props.sessionState}
                    eventReports={state.eventReports}
                    eventUnits={state.eventUnits}
                    eventStates={state.eventStates}
                    eventUrgencyClasses={state.eventUrgencyClasses}
                    eventTypes={state.eventTypes}
                    eventTypeBs={state.eventTypeBs}
                    eventTypeCs={state.eventTypeCs}
                    taskTypes={state.taskTypes}
                    taskUnits={state.taskUnits}
                    taskStates={state.taskStates}
                    recordCharts={state.recordCharts}
                    recordUnits={state.recordUnits}
                    recordFurtherEducationGroups={state.recordFurtherEducationGroups}
                    onFormSchemaReorder={handleFormSchemaReorder}
                    onFormSchemaAddItem={handleFormSchemaAddItem}
                    onFormItemClick={handleFormItemClick}
                    onTaskTypeFormPropUpdate={handleFormTaskTypePropUpdate}
                    onFormTaskDataRowValueUpdate={handleFormTaskDataRowValueUpdate}
                    onFormRemoveComponent={handleFormRemoveComponent}
                    onFormCopyComponent={handleFormCopyComponent}
                    onViewSchema={handleOpenSchemaDialog}
                    onGetDocumentFoldersAndDocuments={appReportService.getAppReportTemplateEditDocumentFoldersAndDocuments}
                />
            }
            {state.activeMenuItem === AppReportTemplateDialogMenuItem.Preview &&
                <TaskTypeDialogPreview
                    appReportDesignMode={true}
                    previewType={TaskTypeDialogPreviewType.Print}
                    taskRepetitionType={TaskRepetitionType.NotRepeated}
                    dataSchema={state.dataSchema}
                    headerDataRow={null}
                    formDataRow={state.formDataRow}
                    lineDataRow={null}
                    //Print preview
                    companyId={props.companyId}
                    code={state.code}
                    printOrientationLandscape={false}
                    //Properties Panel
                    headerTypeCol={null}
                    formTypeCol={state.appReportTemplate?.formCols?.find(item => item?.field === state.formSelectedField)}
                    lineTypeCol={null}
                    lineColumnWidths={[]}
                    onHeaderItemClick={null}
                    onFormItemClick={handleFormItemClick}
                    onTaskTypeHeaderPropUpdate={null}
                    onTaskTypeFormPropUpdate={handleFormTaskTypePropUpdate}
                    onUpdateHeaderDataRowCols={null}
                    onUpdateFormDataRowCols={handleUpdatFormDataRowCols}
                    onChangeLineColumnWidth={null}
                />
            }
            {state.showSchemaDesignerDialog && (
                <TaskTypeDialogSchemaDialog
                    dataSchema={state.dataSchema}
                    onSave={handleSaveSchemaDialog}
                    onClose={handleCloseSchemaDialog}
                />
            )}
        </Box>
        }
        actions={
            <Box display="flex" justifyContent="space-between" width="100%">
                <DialogItemsNav
                    modifyUser={!isNew ? state.item?.modifyUser : null}
                    hasPrevious={props.hasPrevious}
                    hasNext={props.hasNext}
                    onPrevious={handlePrevious}
                    onNext={handleNext}
                />
                <DialogButtons
                    isNew={isNew}
                    onCancel={handleCancel}
                    onRemove={!isNew ? handleRemove : null}
                    onSave={() => handleSave(false)}
                />
            </Box>
        }
        onClose={handleCancel}
    />;
};
